import { IFormOption } from '../../components/_core/_ui/forms.component';

export const HANDEDNESS_LABELS: Record<Handedness, string> = {
  left: 'Left',
  right: 'Right',
};

export const HANDEDNESS_FORM_OPTIONS: IFormOption[] = (Object.keys(HANDEDNESS_LABELS) as Handedness[])
  .map((value) => ({ value, label: HANDEDNESS_LABELS[value] }));

// What a bulk import does with a row that carries no date of birth. Ordered as the
// picker lists them, so the first entry is what an operator gets by default.
export const DATE_OF_BIRTH_FALLBACK_LABELS: Record<DateOfBirthFallback, string> = {
  DATE_ON_FILE: 'Use the date of birth already on file',
  DEFAULT_DATE: 'Use a placeholder date of birth',
};

export const DATE_OF_BIRTH_FALLBACK_FORM_OPTIONS: IFormOption[] = (Object.keys(DATE_OF_BIRTH_FALLBACK_LABELS) as DateOfBirthFallback[])
  .map((value) => ({ value, label: DATE_OF_BIRTH_FALLBACK_LABELS[value] }));

export const DEFAULT_DATE_OF_BIRTH_FALLBACK: DateOfBirthFallback = 'DATE_ON_FILE';

export const PLAYER_MILESTONE_TYPE_LABELS: Record<PlayerMilestoneType, string> = {
  height: 'Height',
  weight: 'Weight',
};

export const PLAYER_MILESTONE_TYPE_FORM_OPTIONS: IFormOption[] = (Object.keys(PLAYER_MILESTONE_TYPE_LABELS) as PlayerMilestoneType[])
  .map((value) => ({ value, label: PLAYER_MILESTONE_TYPE_LABELS[value] }));

export const PLAYER_MILESTONE_TYPE_UNITS: Record<PlayerMilestoneType, string> = {
  height: 'cm',
  weight: 'kg',
};

export type MeasurementSystem = 'metric' | 'imperial';

export const PLAYER_MILESTONE_TYPE_IMPERIAL_UNITS: Record<PlayerMilestoneType, string> = {
  height: 'ft/in',
  weight: 'lbs',
};
